export const state = {
  data: {
    title_estimate: 'PTI - Estimate',
    breadcrumb_estimate: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'PTI',
        href: '/adm/opr/pti',
        active: true,
      },
    ],
    title_approval: 'PTI - Approval',
    breadcrumb_approval: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'PTI',
        href: '/adm/opr/pti',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_pti',
    sortDesc: true,
    fields_estimate: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'code',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'date_estimate',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'app_code',
        label: 'App Code',
      },
      {
        key: 'app_date',
        label: 'App Date',
      },
      {
        key: 'total_eor',
        label: 'Total',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'aksi',
      },
    ],
    fields_approval: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'code',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'date_estimate',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'pti_code',
        label: 'PTI Code',
      },
      {
        key: 'pti_cost',
        label: 'PTI Cost',
      },
      {
        key: 'pti_do',
        label: 'PTI D/O',
      },
      {
        key: 'app_cost',
        label: 'App Cost',
      },
      {
        key: 'app_code',
        label: 'App Code',
      },
      {
        key: 'aksi',
        sortable: true,
      },
    ],
    form: {
      code: '',
      name: '',
      address: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      email: '',
      phone: '',
      fax: '',
      free_storage: '',
      add_storage: '',
      min_storage: '',
      max_storage: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changePti(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  getListEstimate({ commit }, message) {
    commit('changePti', message);
  },

  createBooking({ commit, state }) {
    commit('changePti', {
      loading: true,
    });

    console.log(state.data.form);
  },
};
